"use strict";

var _typeof = require("@babel/runtime-corejs3/helpers/typeof");

var _Object$keys = require("@babel/runtime-corejs3/core-js-stable/object/keys");

var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols");

var _filterInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/filter");

var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");

var _forEachInstanceProperty2 = require("@babel/runtime-corejs3/core-js-stable/instance/for-each");

var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors");

var _Object$defineProperties = require("@babel/runtime-corejs3/core-js-stable/object/define-properties");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.ACTION_DELETE_CONSUMER = void 0;
exports.deleteConsumer = deleteConsumer;
exports.getConsumerActionCreators = getConsumerActionCreators;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _promise = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/promise"));

var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/for-each"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _setTimeout2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/set-timeout"));

var norm = _interopRequireWildcard(require("@rexlabs/entity-normalizer"));

var _lodash = _interopRequireDefault(require("lodash"));

var _invariant = _interopRequireDefault(require("invariant"));

function _getRequireWildcardCache(nodeInterop) { if (typeof _WeakMap !== "function") return null; var cacheBabelInterop = new _WeakMap(); var cacheNodeInterop = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? _Object$getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { _Object$defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) { symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context3; _forEachInstanceProperty2(_context3 = ownKeys(Object(source), true)).call(_context3, function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context4; _forEachInstanceProperty2(_context4 = ownKeys(Object(source))).call(_context4, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

var ACTION_DELETE_CONSUMER = 'entities/UNREGISTER_CONSUMER';
/**
 * Return action creators for consumer handling
 * @param  {string} type
 * @param  {Object} options
 * @return {Object} Object of action creators
 */

exports.ACTION_DELETE_CONSUMER = ACTION_DELETE_CONSUMER;

function getConsumerActionCreators(type, options) {
  return {
    registerConsumer: {
      request: function request(payload, schema, dispatch, getState) {
        return new _promise.default(function (resolve) {
          // The thing is that we have to register as a consumer for every
          //  related item as well, cause (right now) only screens register,
          //  not entities themselves, which they probably should!
          // TODO: implement entity registration for better garbage collection
          var related = payload.related;
          if (!related) resolve();

          var _loop = function _loop(key) {
            // Get related items
            var items = related[key][norm.ITEMS]; // Get related model from options

            var rel = options.related[key];

            if (!rel) {
              return "continue";
            }

            var relModel = _lodash.default.isArray(rel.model) ? rel.model[0] : rel.model;

            if (!relModel) {
              return "continue";
            }

            (0, _forEach.default)(items).call(items, function (id) {
              var _context, _context2;

              var item = _lodash.default.get(getState(), (0, _concat.default)(_context = (0, _concat.default)(_context2 = "entities.".concat(key, ".")).call(_context2, norm.ITEMS, ".")).call(_context, id));

              var itemRelated = {};

              if (item && item.related) {
                itemRelated = item.related;
              } // ...and dispatch register action of related model!


              dispatch(relModel.actionCreators.registerConsumer({
                id: id,
                uuid: payload.uuid,
                related: itemRelated
              }));
            });
            resolve();
          };

          for (var key in related) {
            var _ret = _loop(key);

            if (_ret === "continue") continue;
          }
        });
      },
      reduce: {
        initial: function initial(state, action) {
          return norm.addItemConsumer(state, action.payload.id, action.payload.uuid);
        },
        success: _lodash.default.identity,
        failure: _lodash.default.identity
      }
    },
    registerListConsumer: {
      reduce: function reduce(state, action) {
        // Sanity checks up front
        (0, _invariant.default)(action.payload.id, 'You need to define a list ID to register as consumer.');
        (0, _invariant.default)(action.payload.uuid, 'You need to define your own UUID to register as consumer.'); // Add uuid to lists consumers

        return norm.addListConsumer(state, action.payload.id, action.payload.uuid);
      }
    },
    unregisterConsumer: {
      // This action has a global action name, so all entity models
      //  can simply respond to it (a screen doesn't unregister for a
      //  specific entity, it unregisters in general!)
      actionName: ACTION_DELETE_CONSUMER,
      // Just delay the unregistering, so that any consumer who wants to register
      //  directly afterwards can still consume the data that is already there and
      //  it doesn't get unneccessarily garbage collected!
      request: function request() {
        return new _promise.default(function (resolve) {
          return (0, _setTimeout2.default)(resolve, 10);
        });
      },
      reduce: {
        initial: _lodash.default.identity,
        success: function success(state, action) {
          // Ensure uuid was defined in the original request
          (0, _invariant.default)(action.meta.originalPayload.uuid, "You have to pass in your UUID to unregister as consumer => e.g. 'unregisterConsumer({uuid: 'myId'})");
          return norm.removeConsumerAll(state, action.meta.originalPayload.uuid);
        },
        failure: _lodash.default.identity
      }
    }
  };
}
/**
 * Generic `deleteConsumer` action, that will trigger all entities
 * to check their consumer array and remove the consumer from the list
 * @param  {string} uuid
 * @param  {Object} payload
 * @return {Object} Redux action object with given payload
 */


function deleteConsumer(uuid) {
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return {
    type: ACTION_DELETE_CONSUMER,
    payload: _objectSpread({
      uuid: uuid
    }, payload)
  };
}